import { render, staticRenderFns } from "./userIntegralList.vue?vue&type=template&id=7efbe424&scoped=true&"
import script from "./userIntegralList.vue?vue&type=script&lang=js&"
export * from "./userIntegralList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7efbe424",
  null
  
)

export default component.exports